import { FunctionComponent, h } from 'preact'
import { useContext, useEffect, useMemo, useState } from 'preact/hooks'

import { Textarea } from 'components/ui'
import { TextArea as TextAreaType, TextareaFieldValue } from 'scripts/type'
import { useHandlersWithRequired } from 'components/business/SurveyForm/Fields/hooks'

import FieldWrapper from '../components/FieldWrapper'
import { FieldCommonProps } from '../type'
import FieldsContext from '../fieldsContext'
import usePropValueChange from '../hooks/usePropValueChange'
import styles from './index.scss'

const TextAreaField: FunctionComponent<FieldCommonProps> = (props) => {
  const { field, required, onFieldSubmit } = props
  const [value, setValue] = useState<TextareaFieldValue>({ text: '', screenshots: [] })
  const { isMultipleFields } = useContext(FieldsContext)!
  const [uploading, setUploading] = useState(false)
  const { onNext } = useHandlersWithRequired(setValue, required, onFieldSubmit)
  usePropValueChange(props, () => setValue({ text: '', screenshots: [] }))

  const disabled = useMemo(() => {
    return (required && value.text?.trim().length === 0) || uploading
  }, [required, value.text, uploading])

  useEffect(() => {
    isMultipleFields && onFieldSubmit?.(value)
  }, [value])

  return (
    <FieldWrapper {...props} className={styles.wrapper} handlerProps={{ visible: true, disabled, onNext }}>
      <div className={styles.inputWrapper}>
        <Textarea
          fieldCode={field.code}
          placeholder={(field as TextAreaType).placeholder}
          screenshotsEnabled={(field as TextAreaType).screenshotsEnabled}
          onChange={(value) => setValue(value)}
          onUploadStart={() => setUploading(true)}
          onUploadEnd={() => setUploading(false)}
        />
      </div>
    </FieldWrapper>
  )
}

export default TextAreaField
